import { createWebHistory, createRouter } from "vue-router";
import VueCookies from "vue-cookies";
import store from "@/store";
import userTypeIdSet from "@/components/constants";
import routePaths from "./routePaths.cjs";
// import { CONTACT_INTEREST, getInterestFromPath } from "@/data/contactInterest";
// import { setContactInterest } from "@/utils/contactInterest";

// --- Lazy-loaded route components ---
const ReplenishCredits = () => import("@/views/ReplenishCredits.vue");
const NotFound = () => import("@/views/NotFound.vue");
const HomePage = () => import("@/components/HomePage/HomePage/HomePage.vue");
const PrivacyPolicy = () => import("@/views/PrivacyPolicy.vue");
const TermsAndConditions = () => import("@/views/TermsAndCondition.vue");
const ContactUs = () => import("@/views/Contact.vue");
const LoginScreen = () => import("@/views/Login.vue");
const AboutUs = () => import("@/views/AboutUs.vue");
const OrderConfirmationModal = () =>
  import("@/views/Modals/OrderConfirmation.vue");
const PaymentRetryModal = () => import("@/views/Modals/PaymentRetryModal.vue");
const BankUserDashboard = () =>
  import("@/views/RegisterdUser/Dashboards/BankUserDashboard.vue");
const Products = () => import("@/views/Products.vue");
const BusinessInformationReport = () =>
  import("@/views/BusinessInformationReport.vue");
const GlobalCompanySearch = () => import("@/views/GlobalCompanySearch.vue");
const TradeIntelligence = () => import("@/views/TradeIntelligence.vue");
const TradePriceReview = () => import("@/views/TradePriceReview.vue");
const ApiServices = () => import("@/views/ApiServices.vue");
const InsightLens = () => import("@/views/InsightLens.vue");
// const SelfAssessment = () => import("@/views/SelfAssessment.vue");
const CredenceLearning = () => import("@/views/CredenceLearning.vue");
const BlogsBanner = () => import("@/views/BlogsBanner.vue");
const SearchPage = () => import("@/views/SearchPage.vue");
const PaymentRetry = () => import("@/views/PaymentRetry.vue");
const UserProfile = () => import("@/views/RegisterdUser/UserProfile.vue");
const TeamInvite = () => import("@/views/TeamInvite.vue");
const BanksAndHQ = () => import("@/views/InternalUsersScreens/BanksAndHQ.vue");
const SampleReports = () => import("@/views/SampleReports.vue");
const Rewards = () => import("@/views/Rewards.vue");
const WhatsappTermsAndConditions = () =>
  import("@/views/WhatsappIntegration/TermsAndConditions.vue");
const AllOrders = () => import("@/views/Orders.vue");
const BlogEditor = () => import("@/components/Blogs/BlogsEditor.vue");
const Blog = () => import("@/components/Blogs/Blog.vue");
const ExistingBlogsList = () =>
  import("@/components/Blogs/ExistingBlogsList.vue");
const InstitutionsCorporate = () => import("@/views/Institutions.vue");
const OrderDetails = () => import("@/views/Modals/OrderDetailsModal.vue");
const ManualOrder = () => import("@/views/Modals/ManualOrderModal.vue");
const RmManualOrder = () =>
  import("@/views/Modals/InternalUserModals/RmManualOrder.vue");
const buyCreditsSuccessModal = () =>
  import("@/views/Modals/buyCreditsSuccess.vue");
const CreditPlanAssignment = () => import("@/views/CreditPlanAssignment.vue");
const CreditReconciliation = () => import("@/views/creditReconciliation.vue");
const DataAccessGovernance = () => import("@/views/DataAccessGovernance.vue");
const PriceVerification = () => import("@/views/PriceVerification.vue");
const DigitalReport = () => import("@/views/DigitalReport.vue");
const DigitalProduct = () => import("@/views/DigitalProduct.vue");
// const CompanyProfileWrapper = () => import("@/views/CompanyProfileWrapper.vue");
// const CompanyListings = () => import("@/views/CompanyListings.vue");
// const ChooseReportPackage = () => import("@/views/ChooseReportPackage.vue");
const Partnerships = () => import("@/views/Partnerships.vue");
const DownloadFailure = () => import("@/views/DownloadFailure.vue");

function trackPageView(to) {
  const params = to.query;
  const utmParams = {
    utm_source: params.utm_source,
    utm_medium: params.utm_medium,
    utm_campaign: params.utm_campaign,
    utm_term: params.utm_term,
    utm_content: params.utm_content,
  };

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: to.fullPath,
      page_title: document.title,
      // debug_mode: true, // only for testing in development
      ...utmParams,
    });
  }
}

const routes = [
  {
    name: "new-home",
    component: HomePage,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userTypeId = VueCookies.get("userTypeId");
      if (token) {
        if (userTypeId == userTypeIdSet.viewOnlyExecutiveUserType) {
          next({ name: "Orders" });
        } else {
          next({ name: "SearchForCompanies" });
        }
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "new-home",
        zh: "新-首頁",
        ar: "الصفحة-الرئيسية",
        ko: "새로운-홈",
        th: "บ้านใหม่",
        vi: "trang-chủ-mới",
        bn: "নতুন-হোম",
        ja: "新しいホーム",
      },
    },
  },
  {
    name: "dashboard",
    component: BankUserDashboard,
    beforeEnter: (to, from, next) => {
      const userType = VueCookies.get("user-type");
      const token = VueCookies.get("token");
      if (token) {
        if (
          userType === "RETAIL" ||
          userType === "EXECUTIVE" ||
          userType === "RM"
        ) {
          next({ name: "SearchForCompanies" });
        } else {
          next();
        }
      } else {
        next({ name: "new-home" });
      }
    },
    meta: {
      localizedNames: {
        en: "dashboard",
        zh: "儀表板",
        ar: "لوحة-القيادة",
        ko: "대시보드",
        th: "แผงควบคุม",
        vi: "bảng-điều-khiển",
        bn: "ড্যাশবোর্ড",
        ja: "ダッシュボード",
      },
    },
  },
  {
    name: "blogs-list",
    component: BlogsBanner,
    props: (route) => ({ category: route.params.category || null }),
    meta: {
      localizedNames: {
        en: "blogs-list",
        zh: "博客-列表",
        ar: "قائمة-المدونات",
        ko: "블로그-목록",
        th: "รายการ-บล็อก",
        vi: "danh-sách-blog",
        bn: "ব্লগের-তালিকা",
        ja: "ブログリスト",
      },
    },
  },
  {
    name: "blog",
    component: Blog,
    props: true,
    meta: {
      localizedNames: {
        en: "blog",
        zh: "博客",
        ar: "مدونة",
        ko: "블로그",
        th: "บล็อก",
        vi: "blog",
        bn: "ব্লগ",
        ja: "ブログ",
      },
    },
  },
  {
    name: "blog-editor",
    component: BlogEditor,
    props: { isEditMode: false },
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("BLOG-EDITOR")) {
        next();
      } else if (!token) {
        next({ name: "new-home" });
      } else {
        next({ name: "SearchForCompanies" });
      }
    },
    meta: {
      localizedNames: {
        en: "blog-editor",
        zh: "博客-編輯器",
        ar: "محرر-المدونة",
        ko: "블로그-편집기",
        th: "ตัวแก้ไข-บล็อก",
        vi: "trình-chỉnh-sửa-blog",
        bn: "ব্লগ-সম্পাদক",
        ja: "ブログエディター",
      },
    },
  },
  {
    name: "existing-blog-editor",
    component: BlogEditor,
    props: { isEditMode: true },
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("BLOG-EDITOR")) {
        next();
      } else if (!token) {
        next({ name: "new-home" });
      } else {
        next({ name: "SearchForCompanies" });
      }
    },
    meta: {
      localizedNames: {
        en: "existing-blog-editor",
        zh: "現有博客-編輯器",
        ar: "محرر-المدونة-الحالية",
        ko: "기존-블로그-편집기",
        th: "ตัวแก้ไข-บล็อก-ปัจจุบัน",
        vi: "trình-chỉnh-sửa-blog-hiện-tại",
        bn: "বিদ্যমান-ব্লগ-সম্পাদক",
        ja: "既存のブログエディター",
      },
    },
  },
  {
    name: "ExistingBlogs",
    component: ExistingBlogsList,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("BLOG-EDITOR")) {
        next();
      } else if (!token) {
        next({ name: "new-home" });
      } else {
        next({ name: "SearchForCompanies" });
      }
    },
    meta: {
      localizedNames: {
        en: "ExistingBlogs",
        zh: "現有-博客",
        ar: "المدونات-الحالية",
        ko: "기존-블로그",
        th: "บล็อกที่มีอยู่",
        vi: "blog-hiện-tại",
        bn: "বিদ্যমান-ব্লগগুলি",
        ja: "既存のブログ",
      },
    },
  },
  {
    name: "ExploreOurSampleReports",
    component: SampleReports,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "ExploreOurSampleReports",
        zh: "探索-我們的樣本報告",
        ar: "استكشاف-تقاريرنا-العينة",
        ko: "샘플-보고서-탐색",
        th: "สำรวจรายงานตัวอย่างของเรา",
        vi: "khám-phá-báo-cáo-mẫu",
        bn: "আমাদের-নমুনা-প্রতিবেদন-অন্বেষণ করুন",
        ja: "サンプルレポートを探索する",
      },
    },
  },
  {
    name: "CreditPlanAssignment",
    component: CreditPlanAssignment,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("CREDIT_PLAN_MAPPING")) {
        next();
      } else if (!token) {
        next(from.fullPath);
      } else {
        next(from.fullPath);
      }
    },
    meta: {
      localizedNames: {
        en: "CreditPlanAssignment",
        zh: "信用計劃-分配",
        ar: "تعيين-خطة-الائتمان",
        ko: "신용-계획-할당",
        th: "การมอบหมายแผนเครดิต",
        vi: "phân-bổ-kế-hoạch-tín-dụng",
        bn: "ক্রেডিট-পরিকল্পনা-বরাদ্দ",
        ja: "クレジットプランの割り当て",
      },
    },
  },
  {
    name: "CreditReconciliation",
    component: CreditReconciliation,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("CREDIT_PLAN_MAPPING")) {
        next();
      } else if (!token) {
        next(from.fullPath);
      } else {
        next(from.fullPath);
      }
    },
    meta: {
      localizedNames: {
        en: "CreditReconciliation",
        zh: "信用調解",
        ar: "التسوية-الائتمانية",
        ko: "신용-조정",
        th: "การปรับปรุงเครดิต",
        vi: "đối-soát-tín-dụng",
        bn: "ক্রেডিট-সমন্বয়",
        ja: "クレジット調整",
      },
    },
  },
  {
    name: "DataAccessGovernance",
    component: DataAccessGovernance,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("REPORT_MODULES")) {
        next();
      } else if (!token) {
        next(from.fullPath);
      } else {
        next(from.fullPath);
      }
    },
    meta: {
      localizedNames: {
        en: "DataAccessGovernance",
        zh: "數據訪問治理",
        ar: "حوكمة-الوصول-إلى-البيانات",
        ko: "데이터-접근-거버넌스",
        th: "การกำกับดูแลการเข้าถึงข้อมูล",
        vi: "quản-trị-truy-cập-dữ-liệu",
        bn: "ডেটা-অ্যাক্সেস-শাসন",
        ja: "データアクセスガバナンス",
      },
    },
  },
  {
    name: "CredenceConnectReferralProgram",
    component: Rewards,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "CredenceConnectReferralProgram",
        zh: "Credence-Connect-推薦計劃",
        ar: "برنامج-الإحالة-كريدنس-كونكت",
        ko: "Credence-Connect-추천-프로그램",
        th: "โปรแกรมแนะนำ-Credence-Connect",
        vi: "chương-trình-giới-thiệu-Credence-Connect",
        bn: "CredenceConnect-রেফারেল-প্রোগ্রাম",
        ja: "CredenceConnect紹介プログラム",
      },
    },
  },
  {
    name: "SearchForCompanies",
    props: true,
    component: SearchPage,
    meta: {
      localizedNames: {
        en: "SearchForCompanies",
        zh: "搜尋-公司",
        ar: "البحث-عن-الشركات",
        ko: "회사-검색",
        th: "ค้นหาบริษัท",
        vi: "tìm-kiếm-công-ty",
        bn: "কোম্পানি-অনুসন্ধান",
        ja: "企業を検索",
      },
    },
  },
  //  <!-- Commenting for now, will introduce new pages later on -->

  // {
  //   name: "CompanyProfileList",
  //   props: true,
  //   component: CompanyListings,
  //   meta: {
  //     localizedNames: {
  //       en: "CompanyProfileList",
  //       zh: "公司資料",
  //       ar: "ملف-الشركة",
  //       ko: "회사-프로필",
  //       th: "โปรไฟล์บริษัท",
  //       vi: "hồ-sơ-công-ty",
  //       bn: "কোম্পানির-প্রোফাইল",
  //       ja: "企業プロフィール",
  //     },
  //   },
  // },
  // {
  //   name: "CompanyProfileListByCountry",
  //   props: true,
  //   component: CompanyListings,
  //   meta: {
  //     localizedNames: {
  //       en: "CompanyProfileList",
  //       zh: "公司資料",
  //       ar: "ملف-الشركة",
  //       ko: "회사-프로필",
  //       th: "โปรไฟล์บริษัท",
  //       vi: "hồ-sơ-công-ty",
  //       bn: "কোম্পানির-প্রোফাইল",
  //       ja: "企業プロフィール",
  //     },
  //   },
  // },
  // {
  //   name: "CompanyProfile",
  //   props: true,
  //   component: CompanyProfileWrapper,
  //   meta: {
  //     localizedNames: {
  //       en: "CompanyProfile",
  //       zh: "公司資料",
  //       ar: "ملف-الشركة",
  //       ko: "회사-프로필",
  //       th: "โปรไฟล์บริษัท",
  //       vi: "hồ-sơ-công-ty",
  //       bn: "কোম্পানির-প্রোফাইল",
  //       ja: "企業プロフィール",
  //     },
  //   },
  // },
  // {
  //   name: "ChoosePackage",
  //   props: true,
  //   component: ChooseReportPackage,
  //   meta: {
  //     localizedNames: {
  //       en: "CompanyProfile",
  //       zh: "公司資料",
  //       ar: "ملف-الشركة",
  //       ko: "회사-프로필",
  //       th: "โปรไฟล์บริษัท",
  //       vi: "hồ-sơ-công-ty",
  //       bn: "কোম্পানির-প্রোফাইল",
  //       ja: "企業プロフィール",
  //     },
  //   },
  // },
  {
    name: "OrderConfirmationModal",
    props: true,
    component: OrderConfirmationModal,
    meta: {
      localizedNames: {
        en: "OrderConfirmationModal",
        zh: "訂單-確認-模態框",
        ar: "نموذج-تأكيد-الطلب",
        ko: "주문-확인-모달",
        th: "กล่องยืนยันคำสั่งซื้อ",
        vi: "hộp-xác-nhận-đơn-hàng",
        bn: "কোম্পানির-অনুসন্ধান",
        ja: "企業を検索",
      },
    },
  },
  {
    name: "PaymentRetryModal",
    props: true,
    component: PaymentRetryModal,
    meta: {
      localizedNames: {
        en: "PaymentRetryModal",
        zh: "付款-重試-模態框",
        ar: "نموذج-إعادة-الدفع",
        ko: "결제-재시도-모달",
        th: "กล่องลองชำระเงินใหม่",
        vi: "hộp-thử-lại-thanh-toán",
        bn: "পেমেন্ট-পুনরায়-চেষ্টা-মডাল",
        ja: "支払い再試行モーダル",
      },
    },
  },
  {
    name: "PaymentRetry",
    props: true,
    component: PaymentRetry,
    meta: {
      localizedNames: {
        en: "PaymentRetry",
        zh: "付款-重試",
        ar: "إعادة-الدفع",
        ko: "결제-재시도",
        th: "ลองชำระเงินใหม่",
        vi: "thử-lại-thanh-toán",
        bn: "পেমেন্ট-পুনরায়-চেষ্টা",
        ja: "支払い再試行",
      },
    },
  },
  {
    name: "BuyCreditSuccess",
    props: true,
    component: buyCreditsSuccessModal,
    meta: {
      localizedNames: {
        en: "BuyCreditSuccess",
        zh: "購買-信用-成功",
        ar: "شراء-الرصيد-ناجح",
        ko: "크레딧-구매-성공",
        th: "ซื้อเครดิตสำเร็จ",
        vi: "mua-tín-dụng-thành-công",
        bn: "ক্রেডিট-ক্রয়-সফল",
        ja: "クレジット購入成功",
      },
    },
  },
  {
    name: "BuyCreditFailure",
    props: true,
    component: buyCreditsSuccessModal,
    meta: {
      localizedNames: {
        en: "BuyCreditFailure",
        zh: "購買-信用-失敗",
        ar: "شراء-الرصيد-فشل",
        ko: "크레딧-구매-실패",
        th: "ซื้อเครดิตล้มเหลว",
        vi: "mua-tín-dụng-thất-bại",
        bn: "ক্রেডিট-ক্রয়-ব্যর্থ",
        ja: "クレジット購入失敗",
      },
    },
  },
  {
    name: "ShareYourThoughts",
    component: ContactUs,
    meta: {
      localizedNames: {
        en: "ShareYourThoughts",
        zh: "分享-您的-想法",
        ar: "شارك-أفكارك",
        ko: "생각을-공유하세요",
        th: "แบ่งปันความคิดของคุณ",
        vi: "chia-sẻ-suy-nghĩ-của-bạn",
        bn: "আপনার-মতামত-শেয়ার-করুন",
        ja: "あなたの考えを共有する",
      },
    },
  },
  {
    name: "ProductsPage",
    component: Products,
    meta: {
      localizedNames: {
        en: "ProductsPage",
        zh: "產品-頁面",
        ar: "صفحة-المنتجات",
        ko: "제품-페이지",
        th: "หน้าผลิตภัณฑ์",
        vi: "trang-sản-phẩm",
        bn: "পণ্য-পৃষ্ঠা",
        ja: "製品ページ",
      },
    },
  },
  {
    name: "BusinessInformationReport",
    component: BusinessInformationReport,
    meta: {
      localizedNames: {
        en: "BusinessInformationReport",
        zh: "公司信息报告",
        ar: "تقرير-الشركة-المعلومات",
        ko: "회사-정보-보고서",
        th: "รายงาน-ข้อมูล-บริษัท",
        vi: "bao-cao-thong-tin-cong-ty",
        bn: "কোম্পানি-তথ্য-রিপোর্ট",
        ja: "企業情報レポート",
      },
    },
  },
  {
    name: "GlobalCompanySearch",
    component: GlobalCompanySearch,
    meta: {
      localizedNames: {
        en: "GlobalCompanySearch",
        zh: "全球公司搜索",
        ar: "البحث-عن-الشركات-العالمية",
        ko: "글로벌-기업-검색",
        th: "ค้นหาบริษัททั่วโลก",
        vi: "tim-kiem-cong-ty-toan-cau",
        bn: "গ্লোবাল-কোম্পানি-সার্চ",
        ja: "グローバル企業検索",
      },
    },
  },
  {
    name: "TradeIntelligence",
    component: TradeIntelligence,
    meta: {
      localizedNames: {
        en: "TradeIntelligence",
      },
    },
  },
  {
    name: "TradePriceReview",
    component: TradePriceReview,
    meta: {
      localizedNames: {
        en: "TradePriceReview",
      },
    },
  },
  {
    name: "ApiServices",
    component: ApiServices,
    meta: {
      localizedNames: {
        en: "ApiServices",
      },
    },
  },
  {
    name: "InsightLens",
    component: InsightLens,
    meta: {
      localizedNames: {
        en: "InsightLens",
      },
    },
  },
  // {
  //   name: "SelfAssessment",
  //   component: SelfAssessment,
  //   meta: {
  //     localizedNames: {
  //       en: "SelfAssessment",
  //     },
  //   },
  // },
  {
    name: "CredenceLearning",
    component: CredenceLearning,
    meta: {
      localizedNames: {
        en: "CredenceLearning",
      },
    },
  },
  {
    name: "AboutUs",
    component: AboutUs,
    meta: {
      localizedNames: {
        en: "AboutUs",
        zh: "關於-我們",
        ar: "معلومات-عنا",
        ko: "회사소개",
        th: "เกี่ยวกับเรา",
        vi: "về-chúng-tôi",
        bn: "আমাদের-সম্পর্কে",
        ja: "私たちについて",
      },
    },
  },
  {
    name: "YourProfile",
    props: true,
    component: UserProfile,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "YourProfile",
        zh: "您的-個人資料",
        ar: "ملفك-الشخصي",
        ko: "내-프로필",
        th: "โปรไฟล์ของคุณ",
        vi: "hồ-sơ-của-bạn",
        bn: "আপনার-প্রোফাইল",
        ja: "あなたのプロフィール",
      },
    },
  },
  {
    name: "RM-Admin-portal",
    props: true,
    component: BanksAndHQ,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && userDetails?.includes("ADMIN-CONSOLE")) {
        next();
      } else if (!token) {
        next({ name: "new-home" });
      } else {
        next({ name: "SearchForCompanies" });
      }
    },
    meta: {
      localizedNames: {
        en: "RM-Admin-portal",
        zh: "RM-管理-入口",
        ar: "بوابة-إدارة-RM",
        ko: "RM-관리-포털",
        th: "พอร์ทัลผู้ดูแล-RM",
        vi: "cổng-quản-trị-RM",
        bn: "RM-অ্যাডমিন-পোর্টাল",
        ja: "RM管理ポータル",
      },
    },
  },
  {
    name: "Orders",
    props: true,
    component: () => {
      // const userDetails = store.state.userDetails;
      return import("@/views/BankUserOrders.vue");
    },
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "Orders",
        zh: "訂單",
        ar: "الطلبات",
        ko: "주문",
        th: "คำสั่งซื้อ",
        vi: "đơn-hàng",
        bn: "অর্ডারসমূহ",
        ja: "注文",
      },
    },
  },
  {
    name: "PriceVerification",
    component: PriceVerification,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "PriceVerification",
      },
    },
  },
  {
    name: "AllOrders",
    props: true,
    component: AllOrders,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        to.name = to.params.status;
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "AllOrders",
        zh: "所有-訂單",
        ar: "جميع-الطلبات",
        ko: "모든-주문",
        th: "คำสั่งซื้อทั้งหมด",
        vi: "tất-cả-đơn-hàng",
        bn: "সকল-অর্ডার",
        ja: "すべての注文",
      },
    },
  },
  {
    name: "Institutions",
    component: InstitutionsCorporate,
    meta: {
      localizedNames: {
        en: "Institutions",
        zh: "機構",
        ar: "المؤسسات",
        ko: "기관",
        th: "สถาบัน",
        vi: "tổ-chức",
        bn: "প্রতিষ্ঠানসমূহ",
        ja: "機関",
      },
    },
  },
  {
    name: "Partnerships",
    component: Partnerships,
    meta: {
      localizedNames: {
        en: "Partnerships",
        zh: "機構",
        ar: "المؤسسات",
        ko: "기관",
        th: "สถาบัน",
        vi: "tổ-chức",
        bn: "প্রতিষ্ঠানসমূহ",
        ja: "機関",
      },
    },
  },
  {
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      localizedNames: {
        en: "PrivacyPolicy",
        zh: "隱私政策",
        ar: "سياسة-الخصوصية",
        ko: "개인정보-정책",
        th: "นโยบายความเป็นส่วนตัว",
        vi: "chính-sách-quyền-riêng-tư",
        bn: "গোপনীয়তা-নীতি",
        ja: "プライバシーポリシー",
      },
    },
  },
  {
    name: "TermsAndConditions",
    component: TermsAndConditions,
    meta: {
      localizedNames: {
        en: "TermsAndConditions",
        zh: "隱私政策",
        ar: "سياسة-الخصوصية",
        ko: "개인정보-정책",
        th: "นโยบายความเป็นส่วนตัว",
        vi: "chính-sách-quyền-riêng-tư",
        bn: "গোপনীয়তা-নীতি",
        ja: "プライバシーポリシー",
      },
    },
  },
  {
    name: "CreateOrder",
    component: OrderDetails,
    meta: {
      localizedNames: {
        en: "CreateOrder",
        zh: "創建訂單",
        ar: "إنشاء-طلب",
        ko: "주문-생성",
        th: "สร้างคำสั่งซื้อ",
        vi: "tạo-đơn-hàng",
        bn: "অর্ডার-তৈরি-করুন",
        ja: "注文を作成",
      },
    },
  },
  {
    name: "CreateManualOrder",
    component: ManualOrder,
    meta: {
      localizedNames: {
        en: "CreateManualOrder",
        zh: "創建手動訂單",
        ar: "إنشاء-طلب-يدوي",
        ko: "수동-주문-생성",
        th: "สร้างคำสั่งซื้อด้วยตนเอง",
        vi: "tạo-đơn-hàng-thủ-công",
        bn: "ম্যানুয়াল-অর্ডার-তৈরি-করুন",
        ja: "手動注文を作成",
      },
    },
  },
  {
    name: "CompanySelection",
    component: () => import("@/views/PiOrderCompanyDeatils.vue"),
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userDetails = store.state.userDetails;
      if (token && !userDetails?.includes("OFFLINE-ORDERS")) {
        next();
      } else if (!token) {
        next({ name: "new-home" });
      } else {
        next({ name: "SearchForCompanies" });
      }
    },
    meta: {
      localizedNames: {
        en: "CompanySelection",
        zh: "公司-選擇",
        ar: "شركة-اختيار",
        ko: "회사-선택",
        th: "เลือกบริษัท",
        vi: "chọn-công-ty",
        bn: "কোম্পানি-নির্বাচন",
        ja: "会社の選択",
      },
    },
  },
  {
    name: "CreateSingleOrder",
    component: RmManualOrder,
    meta: {
      localizedNames: {
        en: "CreateSingleOrder",
        zh: "創建單一訂單",
        ar: "إنشاء-طلب-مفرد",
        ko: "단일-주문-생성",
        th: "สร้างคำสั่งซื้อเดี่ยว",
        vi: "tạo-đơn-hàng-đơn",
        bn: "একক-অর্ডার-তৈরি-করুন",
        ja: "単一注文を作成",
      },
    },
  },
  {
    name: "termsandconditions",
    component: WhatsappTermsAndConditions,
  },
  {
    name: "TeamInvite",
    props: true,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      const userTypeId = VueCookies.get("userTypeId");
      if (token) {
        if (userTypeId == userTypeIdSet.viewOnlyExecutiveUserType) {
          next({ name: "Orders" });
        } else {
          next({ name: "SearchForCompanies" });
        }
      } else {
        next();
      }
    },
    component: TeamInvite,
    meta: {
      localizedNames: {
        en: "TeamInvite",
        zh: "團隊-邀請",
        ar: "دعوة-الفريق",
        ko: "팀-초대",
        th: "เชิญทีม",
        vi: "mời-đội-nhóm",
        bn: "টিম-আমন্ত্রণ",
        ja: "チーム招待",
      },
    },
  },
  {
    name: "replenish-credits",
    component: ReplenishCredits,
    props: true,
    meta: {
      localizedNames: {
        en: "replenish-credits",
        zh: "補充-信用",
        ar: "إعادة-شحن-الرصيد",
        ko: "크레딧-보충",
        th: "เติมเครดิต",
        vi: "nạp-tín-dụng",
        bn: "ক্রেডিট-পুনরায়-ভরাট",
        ja: "クレジットを補充",
      },
    },
  },
  {
    name: "Digitalproduct",
    component: DigitalProduct,
    props: true,
  },
  {
    name: "DigitalReport",
    props: true,
    component: DigitalReport,
    beforeEnter: (to, from, next) => {
      const token = VueCookies.get("token");
      if (!token) {
        next({ name: "new-home" });
      } else {
        next();
      }
    },
    meta: {
      localizedNames: {
        en: "DigitalReport",
      },
    },
  },
  {
    name: "Login",
    props: true,
    component: LoginScreen,
  },
  {
    name: "DownloadFailure",
    component: DownloadFailure,
    props: true,
    beforeEnter: (to, from, next) => {
      const { invalid, expired, error } = to.query;
      if (invalid || expired || error) {
        next();
      } else {
        next({
          name: "notFound",
          params: {
            catchAll: to.path.replace(/^\/+/, "") || "download-failure",
          },
          replace: true,
        });
      }
    },
    meta: {
      localizedNames: {
        en: "DownloadFailure",
      },
    },
  },
  {
    name: "notFound",
    component: NotFound,
  },
];

const routesByName = Object.fromEntries(
  routes.map((route) => [route.name, route])
);
const routePathsByName = Object.fromEntries(
  routePaths.map(({ name, path }) => [name, path])
);

for (const route of routes) {
  if (!routePathsByName[route.name]) {
    throw new Error(
      `Missing route path for "${route.name}" in routePaths.cjs. Add it to src/router/routePaths.cjs.`
    );
  }
}

const orderedRoutes = routePaths.map(({ path, name }) => {
  const route = routesByName[name];
  if (!route) {
    throw new Error(
      `Missing route config for "${name}" in router/index.js. Add the full route definition to src/router/index.js.`
    );
  }
  return { ...route, path, name };
});

const router = createRouter({
  history: createWebHistory(),
  routes: orderedRoutes,
  scrollBehavior(to, from, savedPosition) {
    // Keep scroll position when only query/hash changes (e.g. industry section expand)
    if (from && to.path === from.path) {
      return savedPosition || false;
    }
    return { top: 0 };
  },
});

// After a deploy, open tabs still reference old hashed chunks. Reload once so
// the browser picks up the new index.html and chunk URLs.
const CHUNK_RELOAD_KEY = "chunk_load_reload";

function isChunkLoadError(error) {
  const message = error?.message || String(error || "");
  return (
    error?.name === "ChunkLoadError" ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Loading CSS chunk .+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

router.onError((error) => {
  if (!isChunkLoadError(error)) return;
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
});

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

router.beforeEach((to, from, next) => {
  const token = VueCookies.get("token");
  trackPageView(to);

  // if (to.path === "/contact") {
  //   const isInitialLoad = !from.name && from.matched.length === 0;
  //   if (!isInitialLoad) {
  //     const mapped = getInterestFromPath(from.path);
  //     setContactInterest(mapped || CONTACT_INTEREST.GENERAL);
  //   }
  // }

  if (to.name === "Login" && token) {
    next({ name: "new-home" });
  } else {
    next();
  }
});

export default router;
